<!-- <div class="flex justify-center m-6">
    <button scoButton>Button</button>
</div> -->

<router-outlet></router-outlet>
